import { render, staticRenderFns } from "./TransportActionMenu.vue?vue&type=template&id=e23bddd4&"
import script from "./TransportActionMenu.vue?vue&type=script&lang=js&"
export * from "./TransportActionMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports